import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

export const StyledHeaderBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: 2,
} as const;

export const StyledStatsGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
  gap: 2,
  mb: 3,
} as const;

export const StyledStatsPaper = styled(Paper)(({ theme }) => ({
  padding: "20px",
  borderRadius: 8,
  cursor: "pointer",
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledWorkersBox = {
  mb: 2,
  display: "flex",
  gap: 1,
  flexWrap: "wrap",
  alignItems: "center",
} as const;

export const StyledTabsBox = {
  mt: 2,
  display: "flex",
  alignItems: "center",
  gap: 2,
  flexWrap: "wrap",
} as const;

export const StyledTableContainer = styled(Paper)(({ theme }) => ({
  marginTop: 16,
  borderRadius: 8,
  boxShadow: theme.palette.mode === 'dark' ? '0 10px 24px rgba(0,0,0,0.35)' : '0 12px 30px rgba(0,0,0,0.08)',
}));
